import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Fragment } from "react";

function ActionMenuList({
  icon,
  menuList,
  title,
  customStyle,
  size = "",
  param,
  titleColor,
  menuItemStyle = "  ",
  textPosition,
  hideOnEmpty = false,
  position = "down",
  onSelection,
}) {
  let sizeCss = "px-1.5 py-1";
  if (size == "md") {
    sizeCss = "px-2 py-1";
  } else if (size == "md_2") {
    sizeCss = "px-1.5 py-0.5 text-sm";
  } else if (size == "sm") {
    sizeCss = "px-1 py-0.5 text-sm";
  }
  else if (size == "xs") {
    sizeCss = "px-0.5 py-0.1 text-xs";
  }

  let textPos = "text-left";
  if (textPosition) {
    textPos = textPosition;
  }

  if (hideOnEmpty && !(menuList && menuList.length)) {
    return "";
  }

  return (
    <div className={`relative ${textPos}`}>
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button
            className={`${sizeCss}  inline-flex items-center justify-center rounded border gap-[5px] border-gray-d2 font-medium bg-white focus:outline-none    ${
              customStyle ? customStyle : "hover:bg-white text-gray-6c"
            }   `}
          >
            {title}
            {icon || (
              <ChevronDownIcon
                className={`-mr-1 ${title && title != "" && "ml-2"} h-5 w-5`}
                aria-hidden="true"
              />
            )}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className={` absolute ${
              position == "up" ? "bottom-full" : ""
            } right-0 z-50 mt-2 min-w-[150px] w-max origin-top-right rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none right-0 md:right-auto left-auto md:left-0  ${menuItemStyle}`}
          >
            {menuList?.map((v, k) => (
              <div className="mx-1 my-1" key={k}>
                {v && (
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        type="button"
                        onClick={(e) => {
                          v?.onClick && v?.onClick(e, param);
                          onSelection && onSelection(v);
                        }}
                        className={`${
                          active && "bg-gray-50"
                        }  flex w-full font-normal items-center  px-2 py-1   ${
                          v?.labelStyle ? v?.labelStyle : ` text-gray-800 `
                        }  `}
                      >
                        {v?.icon}

                        {v?.label}
                      </button>
                    )}
                  </Menu.Item>
                )}
              </div>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}

export default ActionMenuList;
